module.exports = __webpack_public_path__ + "static/media/left-arrow.ca6e4e31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/left-arrow.svg
// module id = 741
// module chunks = 0